

const ProductNoticePage = () =>{
    return(
        <h1>This is notice product page</h1>
    )
}

export default ProductNoticePage;